import { render } from "./AddRequest.vue?vue&type=template&id=2df17b14&scoped=true"
const script = {}

import "./AddRequest.vue?vue&type=style&index=0&id=2df17b14&scoped=true&lang=css"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2df17b14"]])

export default __exports__